import FileUploadModal from "./FileUploadModal";

type Props = {
    open: boolean;
    onClose: () => void;
    onSelected?: (file: File) => void;
    onUploaded?: (url: string) => void;
    onUploadResponse?: (json: Record<string, unknown>) => void;
    uploadUrl?: string;
    useCookies?: boolean;
    mode?: "deferred" | "immediate";
    title?: string;
};

const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

function validateImage(file: File): string | null {
    if (!file.type.startsWith("image/")) {
        return "Please select an image file (PNG, JPEG, WebP, or GIF).";
    }
    return null;
}

export default function UploadImageModal({
    open,
    onClose,
    onSelected,
    onUploaded,
    onUploadResponse,
    uploadUrl,
    mode = "deferred",
    title = "Upload",
}: Props) {
    return (
        <FileUploadModal
            open={open}
            onClose={onClose}
            title={title}
            accept="image/*"
            maxSizeBytes={MAX_IMAGE_SIZE}
            hint="PNG, JPEG, WebP, or GIF · Max 5MB"
            previewMode="image"
            validateFile={validateImage}
            mode={mode}
            onSelected={onSelected}
            uploadUrl={uploadUrl}
            onUploadResponse={onUploadResponse}
            onUploaded={(url) => {
                if (url) onUploaded?.(url);
                else onUploaded?.("");
            }}
            submitLabel={mode === "deferred" ? "Use this image" : undefined}
        />
    );
}
